/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Reason for card cancellation
 */
export type CancelCardBodyReason = typeof CancelCardBodyReason[keyof typeof CancelCardBodyReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancelCardBodyReason = {
  lost: 'lost',
  stolen: 'stolen',
  damaged: 'damaged',
  expired: 'expired',
  other: 'other',
} as const;
